/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleMinus2 = createReactComponent("circle-minus-2", "IconCircleMinus2", [
  ["path", { d: "M20.475 15.029a9 9 0 1 0 -7.962 5.957", key: "svg-0" }],
  ["path", { d: "M16 19h6", key: "svg-1" }]
]);

export { IconCircleMinus2 as default };
//# sourceMappingURL=IconCircleMinus2.js.map
